(function() {
  const API_URL = 'https://superagent-befeaff5.base44.app/functions/browseJDSCatalog';
  const QUOTE_URL = 'https://superagent-befeaff5.base44.app/functions/submitJDSQuote';

  const container = document.getElementById('rbc-jds-catalog');
  if (!container) return;

  let state = {
    view: 'categories', // categories | products | detail
    category: null,
    categoryLabel: null,
    page: 1,
    categories: null,
    products: null,
    detail: null,
    qty: 24,
    loading: false,
    error: null,
    cart: [],
    cartOpen: false,
    showQuoteForm: false,
    quoteSubmitted: false,
    quoteResult: null,
    searchQuery: '',
    searchResults: null,
    searching: false,
  };

  async function apiFetch(params) {
    try {
      state.loading = true;
      state.error = null;
      render();
      const resp = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
      });
      const data = await resp.json();
      state.loading = false;
      if (data.error) state.error = data.error;
      return data;
    } catch (e) {
      state.loading = false;
      state.error = 'Failed to load catalog. Please try again.';
      render();
      return null;
    }
  }

  async function loadCategories() {
    const data = await apiFetch({ action: 'categories' });
    if (data) state.categories = data.categories;
    render();
  }

  async function browseCategory(catId) {
    state.view = 'products';
    state.category = catId;
    state.page = 1;
    const data = await apiFetch({ action: 'browse', category: catId, page: 1, pageSize: 12 });
    if (data) { state.products = data; state.categoryLabel = data.categoryLabel; }
    render();
  }

  async function loadPage(p) {
    state.page = p;
    const data = await apiFetch({ action: 'browse', category: state.category, page: p, pageSize: 12 });
    if (data) state.products = data;
    render();
    container.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  async function viewDetail(sku) {
    state.view = 'detail';
    state.qty = 24;
    const data = await apiFetch({ action: 'detail', sku });
    if (data) state.detail = data.product;
    render();
  }

  function goBack() {
    if (state.view === 'detail') { state.view = 'products'; state.detail = null; }
    else if (state.view === 'products') { state.view = 'categories'; state.products = null; state.category = null; state.searchResults = null; }
    render();
  }

  function setQty(q) {
    state.qty = Math.max(1, q);
    render();
  }

  function addToCart() {
    if (!state.detail) return;
    const existing = state.cart.find(i => i.sku === state.detail.sku);
    if (existing) {
      existing.qty += state.qty;
    } else {
      state.cart.push({
        sku: state.detail.sku,
        name: state.detail.name,
        image: state.detail.thumbnail || state.detail.image,
        qty: state.qty,
        unitPrice: priceForQty(state.detail, state.qty),
      });
    }
    state.cartOpen = true;
    render();
  }

  function priceForQty(product, qty) {
    const vp = product.volumePricing;
    if (!vp) return product.retailPrice;
    if (qty >= (product.caseQty * 10)) return vp.tenCases;
    if (qty >= (product.caseQty * 5)) return vp.fiveCases;
    if (qty >= product.caseQty) return vp.oneCase;
    return vp.single;
  }

  function removeFromCart(sku) {
    state.cart = state.cart.filter(i => i.sku !== sku);
    render();
  }

  function cartTotal() {
    return state.cart.reduce((sum, i) => sum + (i.unitPrice * i.qty), 0);
  }

  function cartCount() {
    return state.cart.reduce((sum, i) => sum + i.qty, 0);
  }

  function toggleCart() {
    state.cartOpen = !state.cartOpen;
    render();
  }

  function openQuoteForm() {
    state.showQuoteForm = true;
    state.cartOpen = false;
    render();
  }

  async function submitQuote(e) {
    e.preventDefault();
    const form = e.target;
    const payload = {
      customerName: form.name.value,
      customerEmail: form.email.value,
      customerPhone: form.phone.value,
      company: form.company.value,
      notes: form.notes.value,
      items: state.cart,
      total: cartTotal(),
    };

    state.loading = true;
    render();

    try {
      const resp = await fetch(QUOTE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await resp.json();
      state.loading = false;
      state.quoteSubmitted = true;
      state.quoteResult = data;
      state.cart = [];
      render();
    } catch (err) {
      state.loading = false;
      state.error = 'Could not submit your quote request. Please call us at (385) 626-7137.';
      render();
    }
  }

  async function runSearch(q) {
    state.searchQuery = q;
    if (!q || q.length < 2) { state.searchResults = null; render(); return; }
    state.searching = true;
    render();
    const data = await apiFetch({ action: 'search', query: q });
    state.searching = false;
    if (data) state.searchResults = data.products;
    render();
  }

  function esc(s) {
    const d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }

  function render() {
    let html = '';

    html += `<div class="rbc-header">
      ${state.view !== 'categories' ? '<button class="rbc-back" id="rbc-back-btn">&larr; Back</button>' : ''}
      <h3>${state.view === 'categories' ? 'Browse Promotional Products' : esc(state.categoryLabel || '')}</h3>
      <button class="rbc-cart-btn" id="rbc-cart-toggle">🛒 Quote Cart ${state.cart.length ? `<span class="rbc-cart-badge">${cartCount()}</span>` : ''}</button>
    </div>`;

    if (state.error) {
      html += `<div class="rbc-error">${esc(state.error)}</div>`;
    }

    if (state.view === 'categories') {
      html += `<div class="rbc-search-bar">
        <input type="text" id="rbc-search-input" placeholder="Search all products (e.g. 'tumbler', 'medal', 'patch')..." value="${esc(state.searchQuery)}" />
      </div>`;

      if (state.searching) {
        html += `<div class="rbc-loading"><div class="rbc-spinner"></div></div>`;
      } else if (state.searchResults) {
        html += `<div class="rbc-count">${state.searchResults.length} result${state.searchResults.length === 1 ? '' : 's'} for "${esc(state.searchQuery)}"</div>`;
        html += `<div class="rbc-grid">`;
        state.searchResults.forEach(p => { html += productCard(p); });
        html += `</div>`;
        if (!state.searchResults.length) {
          html += `<p class="rbc-empty">No matches. Try browsing categories below, or call us at (385) 626-7137 — we source from a huge catalog.</p>`;
        }
      } else if (state.loading && !state.categories) {
        html += `<div class="rbc-loading"><div class="rbc-spinner"></div></div>`;
      } else if (state.categories) {
        html += `<div class="rbc-cat-grid">`;
        state.categories.forEach(c => {
          html += `<button class="rbc-cat-card" data-cat="${esc(c.id)}">
            <span class="rbc-cat-name">${esc(c.label)}</span>
            <span class="rbc-cat-count">${c.count} items</span>
          </button>`;
        });
        html += `</div>`;
      }
    } else if (state.view === 'products') {
      if (state.loading) {
        html += `<div class="rbc-loading"><div class="rbc-spinner"></div></div>`;
      } else if (state.products) {
        html += `<div class="rbc-count">${state.products.total} products</div>`;
        html += `<div class="rbc-grid">`;
        (state.products.products || []).forEach(p => { html += productCard(p); });
        html += `</div>`;
        if (state.products.totalPages > 1) {
          html += `<div class="rbc-pagination">`;
          for (let i = 1; i <= state.products.totalPages && i <= 10; i++) {
            html += `<button class="rbc-page-btn ${i === state.page ? 'active' : ''}" data-page="${i}">${i}</button>`;
          }
          if (state.products.totalPages > 10) html += `<span class="rbc-page-more">... ${state.products.totalPages} total</span>`;
          html += `</div>`;
        }
      }
    } else if (state.view === 'detail' && state.detail) {
      const p = state.detail;
      const unitPrice = priceForQty(p, state.qty);
      html += `<div class="rbc-detail">
        <div class="rbc-detail-image"><img src="${esc(p.image || p.thumbnail)}" alt="${esc(p.name)}" onerror="this.style.display='none'"/></div>
        <div class="rbc-detail-info">
          <h4>${esc(p.name)}</h4>
          <p class="rbc-sku">SKU: ${esc(p.sku)}</p>
          <p class="rbc-desc">${esc(p.description || '')}</p>
          <p class="rbc-stock ${p.inStock ? 'in' : 'out'}">${p.inStock ? `✓ In stock (${p.availableQty.toLocaleString()} available)` : 'Contact us for availability'}</p>

          <div class="rbc-volume-table">
            <table>
              <tr><th>Qty</th><th>Price/ea</th></tr>
              <tr class="${state.qty < p.caseQty ? 'active-row' : ''}"><td>1 - ${p.caseQty - 1}</td><td>$${p.volumePricing.single.toFixed(2)}</td></tr>
              <tr class="${state.qty >= p.caseQty && state.qty < p.caseQty * 5 ? 'active-row' : ''}"><td>${p.caseQty}+ (1 case)</td><td>$${p.volumePricing.oneCase.toFixed(2)}</td></tr>
              <tr class="${state.qty >= p.caseQty * 5 && state.qty < p.caseQty * 10 ? 'active-row' : ''}"><td>${p.caseQty * 5}+ (5 cases)</td><td>$${p.volumePricing.fiveCases.toFixed(2)}</td></tr>
              <tr class="${state.qty >= p.caseQty * 10 ? 'active-row' : ''}"><td>${p.caseQty * 10}+ (10 cases)</td><td>$${p.volumePricing.tenCases.toFixed(2)}</td></tr>
            </table>
          </div>

          <div class="rbc-qty-selector">
            <label>Quantity:</label>
            <button class="rbc-qty-btn" id="rbc-qty-minus">-</button>
            <input type="number" id="rbc-qty-input" value="${state.qty}" min="1" />
            <button class="rbc-qty-btn" id="rbc-qty-plus">+</button>
          </div>

          <div class="rbc-price-line">
            <span class="rbc-unit-price">$${unitPrice.toFixed(2)} / unit</span>
            <span class="rbc-total-price">$${(unitPrice * state.qty).toFixed(2)} total</span>
          </div>
          <p class="rbc-custom-note">Includes custom logo/text personalization (laser engraving or UV printing, depending on material).</p>

          <button class="rbc-add-cart-btn" id="rbc-add-to-cart">Add to Quote Cart</button>
        </div>
      </div>`;
    }

    if (state.cartOpen) {
      html += `<div class="rbc-cart-overlay" id="rbc-cart-overlay">
        <div class="rbc-cart-panel">
          <div class="rbc-cart-header">
            <h4>Your Quote Cart</h4>
            <button class="rbc-cart-close" id="rbc-cart-close">&times;</button>
          </div>
          ${!state.cart.length ? '<p class="rbc-empty">Your cart is empty. Browse products and add items to build a quote.</p>' : `
            <div class="rbc-cart-items">
              ${state.cart.map(i => `
                <div class="rbc-cart-item">
                  <img src="${esc(i.image)}" alt="${esc(i.name)}" onerror="this.style.display='none'"/>
                  <div class="rbc-cart-item-info">
                    <div class="rbc-cart-item-name">${esc(i.name)}</div>
                    <div class="rbc-cart-item-meta">Qty: ${i.qty} &times; $${i.unitPrice.toFixed(2)} = $${(i.qty * i.unitPrice).toFixed(2)}</div>
                  </div>
                  <button class="rbc-cart-remove" data-sku="${esc(i.sku)}">&times;</button>
                </div>
              `).join('')}
            </div>
            <div class="rbc-cart-total">Estimated Total: <strong>$${cartTotal().toFixed(2)}</strong></div>
            <button class="rbc-request-quote-btn" id="rbc-request-quote">Request Formal Quote</button>
          `}
        </div>
      </div>`;
    }

    if (state.showQuoteForm) {
      html += `<div class="rbc-cart-overlay" id="rbc-quote-overlay">
        <div class="rbc-cart-panel rbc-quote-panel">
          ${state.quoteSubmitted ? `
            <div class="rbc-quote-success">
              <h4>Thanks! Your quote request is in.</h4>
              <p>We'll follow up within two business days with pricing confirmation and next steps. Questions? Call (385) 626-7137.</p>
              <button class="rbc-add-cart-btn" id="rbc-quote-done">Done</button>
            </div>
          ` : `
            <div class="rbc-cart-header">
              <h4>Request a Quote</h4>
              <button class="rbc-cart-close" id="rbc-quote-close">&times;</button>
            </div>
            <form id="rbc-quote-form">
              <label>Name<input type="text" name="name" required /></label>
              <label>Email<input type="email" name="email" required /></label>
              <label>Phone<input type="tel" name="phone" /></label>
              <label>Company<input type="text" name="company" /></label>
              <label>Notes (deadlines, artwork, etc.)<textarea name="notes" rows="3"></textarea></label>
              <button type="submit" class="rbc-add-cart-btn" ${state.loading ? 'disabled' : ''}>${state.loading ? 'Submitting...' : 'Submit Quote Request'}</button>
            </form>
          `}
        </div>
      </div>`;
    }

    container.innerHTML = html;
    attachHandlers();
  }

  function productCard(p) {
    return `<div class="rbc-product-card" data-sku="${esc(p.sku)}">
      <div class="rbc-product-image"><img src="${esc(p.thumbnail || p.image)}" alt="${esc(p.name)}" loading="lazy" onerror="this.style.display='none'"/></div>
      <div class="rbc-product-name">${esc(p.name)}</div>
      <div class="rbc-product-price">from $${p.volumePricing.oneCase.toFixed(2)}/ea</div>
      ${!p.inStock ? '<div class="rbc-product-oos">Check availability</div>' : ''}
    </div>`;
  }

  function attachHandlers() {
    const backBtn = document.getElementById('rbc-back-btn');
    if (backBtn) backBtn.onclick = goBack;

    const cartToggle = document.getElementById('rbc-cart-toggle');
    if (cartToggle) cartToggle.onclick = toggleCart;

    const cartClose = document.getElementById('rbc-cart-close');
    if (cartClose) cartClose.onclick = toggleCart;

    const cartOverlay = document.getElementById('rbc-cart-overlay');
    if (cartOverlay) cartOverlay.onclick = (e) => { if (e.target === cartOverlay) toggleCart(); };

    const requestQuoteBtn = document.getElementById('rbc-request-quote');
    if (requestQuoteBtn) requestQuoteBtn.onclick = openQuoteForm;

    const quoteClose = document.getElementById('rbc-quote-close');
    if (quoteClose) quoteClose.onclick = () => { state.showQuoteForm = false; render(); };

    const quoteDone = document.getElementById('rbc-quote-done');
    if (quoteDone) quoteDone.onclick = () => { state.showQuoteForm = false; state.quoteSubmitted = false; render(); };

    const quoteOverlay = document.getElementById('rbc-quote-overlay');
    if (quoteOverlay) quoteOverlay.onclick = (e) => { if (e.target === quoteOverlay) { state.showQuoteForm = false; render(); } };

    const quoteForm = document.getElementById('rbc-quote-form');
    if (quoteForm) quoteForm.onsubmit = submitQuote;

    document.querySelectorAll('.rbc-cat-card').forEach(el => {
      el.onclick = () => browseCategory(el.dataset.cat);
    });

    document.querySelectorAll('.rbc-product-card').forEach(el => {
      el.onclick = () => viewDetail(el.dataset.sku);
    });

    document.querySelectorAll('.rbc-page-btn').forEach(el => {
      el.onclick = () => loadPage(parseInt(el.dataset.page, 10));
    });

    document.querySelectorAll('.rbc-cart-remove').forEach(el => {
      el.onclick = (e) => { e.stopPropagation(); removeFromCart(el.dataset.sku); };
    });

    const qtyInput = document.getElementById('rbc-qty-input');
    if (qtyInput) qtyInput.onchange = (e) => setQty(parseInt(e.target.value, 10) || 1);

    const qtyMinus = document.getElementById('rbc-qty-minus');
    if (qtyMinus) qtyMinus.onclick = () => setQty(state.qty - 1);

    const qtyPlus = document.getElementById('rbc-qty-plus');
    if (qtyPlus) qtyPlus.onclick = () => setQty(state.qty + 1);

    const addCartBtn = document.getElementById('rbc-add-to-cart');
    if (addCartBtn) addCartBtn.onclick = addToCart;

    const searchInput = document.getElementById('rbc-search-input');
    if (searchInput) {
      searchInput.focus();
      searchInput.setSelectionRange(searchInput.value.length, searchInput.value.length);
      let debounce;
      searchInput.oninput = (e) => {
        clearTimeout(debounce);
        const v = e.target.value;
        debounce = setTimeout(() => runSearch(v), 500);
      };
    }
  }

  loadCategories();
})();
